import { urlParameterCodes } from '@/constants/urlParams';
import { useShallowRouter } from '@/ui/hooks/useShallowRouter';
import { ManufacturerOption } from '../types/ManufacturerOption';

export const useUpdateKnobUrlParam = () => {
  const shallowRouter = useShallowRouter();
  const updateKnobUrlParam = (
    currentPath: string,
    doorKnobSelected: boolean,
    selectedManufacturer?: ManufacturerOption,
  ) => {
    shallowRouter.replace(
      currentPath,
      {
        [urlParameterCodes.productDetail.doorKnob]: doorKnobSelected
          ? selectedManufacturer?.value
          : undefined,
      },
      true,
    );
  };

  return updateKnobUrlParam;
};
